import type { StateStore } from "../app/state/StateStore";

import { BaseBlock } from "./BaseBlock";

/**
 * Первый блок Krok.
 *
 * Показывает:
 * - название курса;
 * - название урока;
 * - название Krok.
 */
export class KrokHeaderBlock extends BaseBlock {

    constructor(
        private readonly store: StateStore
    ) {
        super();
    }

    public override mount(): void {

        this.root = this.render();

    }

    public override update(): void {

        const newRoot =
            this.render();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    private render(): HTMLElement {

        const wrapper =
            document.createElement("div");

        wrapper.className =
            "task explanation-task";

        const krok =
            this.store.getState().krok;

        if (!krok) {
            return wrapper;
        }

        wrapper.innerHTML = `
            <h2>${krok.product_title}</h2>
            <h3>${krok.lesson_title}</h3>
            <p><strong>${krok.title}</strong></p>
        `;

        return wrapper;

    }

}